import { ThresholdPrice } from '@/utils/commission/constants';
import { PROVINCES } from '@/constants';

export const ListSideCommissionRates = [
  {
    value: 3.78,
    thresholdPrice: ThresholdPrice.Min,
  },
  {
    value: 1.35,
    thresholdPrice: ThresholdPrice.Max,
  },
];

export const StartPrice = {
  [PROVINCES.AB]: 800000,
  [PROVINCES.BC]: 1000000,
  [PROVINCES.ON]: 1000000,
};

export const MinMaxPrice = {
  MIN: 100000,
  MAX: 5000000,
};

export const MinMaxCommissionValue = {
  MIN: 0,
  MAX: 10000,
};

export const options = [
  {
    name: 'province',
    id: 'select-AB',
    value: PROVINCES.AB,
    text: 'Alberta',
  },
  {
    name: 'province',
    id: 'select-BC',
    value: PROVINCES.BC,
    text: 'British Columbia',
  },
  {
    name: 'province',
    id: 'select-ON',
    value: PROVINCES.ON,
    text: 'Ontario',
  },
];

export default {
  StartPrice,
  MinMaxPrice,
  options,
};
